<template>
  <CourseBlock
    title-margin="small"
    class="course-content"
  >
    <template #title>
      {{ title }}
    </template>

    <template #content>
      <p
        class="course-content__description p p--2"
        v-html="description"
      />

      <ul class="course-content__list f f--1 f--m">
        <li v-if="info.courses" class="course-content__item">
          <svg-icon
            name="basic/ui-lock"
            width="20"
            height="20"
            class="course-content__item-icon"
            aria-hidden="true"
          />

          {{ info.courses }}
        </li>

        <li v-if="info.modules" class="course-content__item">
          <svg-icon
            name="basic/ui-university"
            width="20"
            height="20"
            class="course-content__item-icon"
            aria-hidden="true"
          />

          {{ info.modules }}
        </li>

        <li v-if="info.topics" class="course-content__item">
          <svg-icon
            name="basic/ui-heart"
            width="20"
            height="20"
            class="course-content__item-icon"
            aria-hidden="true"
          />

          {{ info.topics }}
        </li>

        <li v-if="info.hours" class="course-content__item">
          <svg-icon
            name="basic/ui-student"
            width="20"
            height="20"
            class="course-content__item-icon"
            aria-hidden="true"
          />

          {{ info.hours }}
        </li>
      </ul>

      <UiAccordion
        :data="slicedData"
        class="course-content__accordion"
      />

      <UiButton
        v-if="data.length > MAX_DATA"
        theme="quaternary"
        size="big"
        stretch
        class="course-content__button"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'Скрыть' : 'Показать ещё' }}
      </UiButton>
    </template>
  </CourseBlock>
</template>

<script setup lang="ts">
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import UiAccordion from '@academica-box/components/Blocks/UiAccordion/UiAccordion.vue'
  import CourseBlock from '@/components/CourseBlock.vue'

  const props = defineProps<{
    title: string;
    description: string;
    info: {
      courses?: string;
      modules?: string;
      topics?: string;
      hours?: string;
    };
    data: {
      title: string;
      description: string;
    }[];
  }>()

  const MAX_DATA = 4
  const isExpanded = ref(false)

  const slicedData = computed(() => {
    return isExpanded.value ? props.data : [...props.data].splice(0, MAX_DATA)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiReset' as *;

  .course-content__description {
    margin-bottom: 20px;
    color: var(--text-secondary-color);

    @include media(lg) {
      margin-bottom: 32px;
    }
  }

  .course-content__list {
    @include ulres;

    margin-bottom: 48px;
    padding: 24px 20px;
    border-radius: 16px;
    background-color: var(--bg-secondary-color);

    @include media(360) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }

    @include media(lg) {
      display: flex;
      width: min-content;
      margin-bottom: 64px;
      padding: 12px 20px;
    }
  }

  .course-content__item {
    display: flex;
    align-items: center;
    white-space: nowrap;

    &:not(:first-child) {
      @include media(lg) {
        position: relative;
        padding-left: 24px;

        &:before {
          position: absolute;
          left: -3px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: var(--text-main-color);
          content: "";
        }
      }
    }

    &:not(:last-child) {
      margin-bottom: 20px;

      @include media(360) {
        margin: 0;
      }
    }
  }

  .course-content__item-icon {
    margin-right: 10px;
  }

  .course-content__accordion {
    margin-bottom: 20px;

    @include media(lg) {
      margin-bottom: 32px;
    }
  }
</style>
